import { Divider, Stack, Typography } from "@mui/material";

type SectionHeaderProps = {
	title: string;
	isFirst?: boolean;
};

const SectionHeader = ({ title, isFirst = false }: SectionHeaderProps) => {
	return (
		<Stack
			direction="row"
			alignItems="center"
			spacing={2}
			sx={{ mt: isFirst ? 0 : 3, mb: 1.5 }}>
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ whiteSpace: "nowrap" }}>
				{title.toLocaleUpperCase()}
			</Typography>
			<Divider sx={{ flexGrow: 1 }} />
		</Stack>
	);
};

export default SectionHeader;
